// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__-j-s9","mainContent":"styles_mainContent__fpE89","coinImage":"styles_coinImage__xBQk2"};